import { BffResponseRetrofitAdapter } from 'stores/adapters/bex-api/migration-adapters';

import { ResultType } from 'constants/resultType';

export const splitMessagesFromLodging: BffResponseRetrofitAdapter = searchResults =>
  searchResults && Array.isArray(searchResults.hotels)
    ? {
        ...searchResults,
        ...searchResults.hotels.reduce(
          (accumulator, listing, index) => {
            listing.resultType === ResultType.MESSAGING
              ? accumulator.messages.push({ ...listing, index })
              : accumulator.hotels.push(listing);

            return accumulator;
          },
          { hotels: [], messages: [] }
        )
      }
    : { ...searchResults, hotels: [], messages: [] };
